import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@ami/react/core';
import { Machine } from '../machines/machine';
import { MachineFilter } from '../machines/machineFilter';

const otherMachineId = 'OTHER-MACHINE';

export class MachineModelDropdown extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    noOptions: PropTypes.string,
    selectedId: PropTypes.string,
    onChange: PropTypes.func,
    onChangeItem: PropTypes.func,
    isClearable: PropTypes.bool,
    className: PropTypes.string,
    make: PropTypes.string,
    carrierId: PropTypes.string,
    weightCategoryId: PropTypes.string,
    includeOtherMachine: PropTypes.bool,
    preferredMakeIds: PropTypes.arrayOf(PropTypes.string),
  };

  state = {
    items: [],
    isLoading: false,
  };

  async componentDidMount() {
    if (this.props.make) {
      await this.getModels();
    }
  }

  async componentDidUpdate(prevProps) {
    if (
      prevProps.make !== this.props.make ||
      prevProps.carrierId !== this.props.carrierId ||
      prevProps.weightCategoryId !== this.props.weightCategoryId
    ) {
      await this.getModels();
    }
  }

  getModels = async () => {
    const {
      make,
      carrierId,
      weightCategoryId,
      includeOtherMachine,
      preferredMakeIds,
    } = this.props;
    if (!make) {
      this.setState({ items: [] }, () => {
        this.setState({ isLoading: false });
      });
      return;
    }
    this.setState({ isLoading: true });
    const machines = await Machine.search(
      new MachineFilter({
        manufacturer: make,
        carrierId: carrierId,
        weightCategoryId: weightCategoryId,
        onlyActives: true,
      })
    );
    var models = machines.map((x) => ({
      id: x.id,
      label: x.model,
      make: x.manufacturer,
    }));

    if (preferredMakeIds) {
      const firstPriority = [];
      const lastPriority = [];
      models.forEach((item) => {
        if (preferredMakeIds.includes(item.label)) firstPriority.push(item);
        else lastPriority.push(item);
      });
      models = [...firstPriority, ...lastPriority];
    }

    if (includeOtherMachine)
      models.unshift({ id: otherMachineId, label: 'Other' });

    this.setState({ items: models }, () => {
      this.setState({ isLoading: false });
    });
  };

  render() {
    const {
      placeholder,
      noOptions,
      selectedId,
      onChange,
      onChangeItem,
      isClearable,
      className,
      ...rest
    } = this.props;
    const { items, isLoading } = this.state;
    return (
      <Dropdown
        placeholder={placeholder || 'All'}
        noOptions={noOptions}
        items={items}
        selectedId={selectedId}
        //onChange={onChange}
        onChange={(value) => {
          if (onChange) onChange(value);
          if (onChangeItem)
            onChangeItem(value ? items.find((x) => x.id === value) : value);
        }}
        isClearable={isClearable}
        className={className}
        isLoading={isLoading}
        forceSearchable={true}
        {...rest}
      />
    );
  }
}
